// extracted by mini-css-extract-plugin
export var logo = "style-module--logo--93573";
export var siteMain = "style-module--site-main--a6456";
export var siteMain__content = "style-module--site-main__content--5fc0b";